import { useProfileQuery } from '@/services/customer/profile/profile.queries';

export const useMyRole = () => {
    const { data, isLoading } = useProfileQuery();

    return {
        role: data?.account_role,
        isTechnicalSupport: data?.account_role === 'technical_support',
        isLoading
    };
};
